import type {Extension} from '@codemirror/state'
import {EditorView} from '@codemirror/view'

function visitingLink(mouseEvent: MouseEvent) {
  return mouseEvent.target instanceof HTMLAnchorElement && (mouseEvent.metaKey || mouseEvent.ctrlKey)
}

/**
 * Navigate to links when the `Mod` key is held down while clicking;
 * plain clicking simply moves the caret as with other editable text.
 */
function handleClick(mouseEvent: MouseEvent) {
  if (visitingLink(mouseEvent)) {
    const anchorElement = mouseEvent.target as HTMLAnchorElement
    window.open(anchorElement.href, '_blank', 'noopener,noreferrer')
    mouseEvent.preventDefault()
    return true // event handled
  }
}

/** Extension that handles clicks on the editor by navigating to links when they're the click target. */
export function visitLinkExtension(): Extension {
  return [
    EditorView.domEventHandlers({
      click: handleClick,
      mousedown: mouseEvent => {
        // Prevent caret getting moved when trying to visit a link.
        // Note this doesn't prevent the `click` event from subsequently firing, you'd need to stop propagation to do
        // that
        if (visitingLink(mouseEvent)) {
          mouseEvent.preventDefault()
          return true
        }
      },
    }),
  ]
}
